module.exports = __webpack_public_path__ + "static/media/intern5.d9a0e288.jpg";